import React, { PureComponent, Fragment } from 'react'
import { AppBar, Toolbar, IconButton, Typography, Button } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'

import { Nav, DatePicker, Statements, WaitingListIcon } from 'components'
import { createReadableDate } from 'services/helpers'

export class HeaderBase extends PureComponent {
  state = {
    openNav: false
  }

  onLinkClickHandler = path => () => {
    const { push } = this.props

    this.toggleNav()

    push(path)
  }

  toggleNav = () => {
    this.setState(prevState => ({
      openNav: !prevState.openNav
    }))
  }

  renderTitle = () => {
    const { routeName, date, isLogisticPage, isPricesPage, isRoutesPage, isUsersPage } = this.props

    if (isUsersPage) {
      return 'Управління користувачами'
    } else if (!routeName) {
      return 'Оберіть маршрут'
    } else if (isLogisticPage || isPricesPage || isRoutesPage) {
      return routeName
    } else {
      const readableDate = createReadableDate(date)

      return `${readableDate} ${routeName}`
    }
  }

  render() {
    const { openNav } = this.state
    const { classes, signOut, isLogisticPage, isPricesPage, userName, isWebsiteBookingsPage, routeName } = this.props

    // const showDatePicker = isPricesPage || isLogisticPage
    const showDatePicker = isLogisticPage || isWebsiteBookingsPage

    return (
      <Fragment>
        <AppBar position='fixed'>
          <Toolbar variant='dense'>

            <IconButton color='inherit' onClick={this.toggleNav}>
              <MenuIcon />
            </IconButton>

            <Typography className={classes.title} variant='subtitle1' color='inherit'>
              {this.renderTitle()}
            </Typography>

            {isLogisticPage && <Statements />}
            {showDatePicker && <DatePicker />}

            {!!routeName && <WaitingListIcon />}

            <Typography 
              color='inherit'
              variant='subtitle1' 
              className={classes.userName}
            >
              Вітаю {userName}!
            </Typography>

            <Button color='inherit' onClick={signOut}>Вийти</Button>
            
          </Toolbar>
        </AppBar>

        <Nav 
          open={openNav}
          toggleNav={this.toggleNav}
          onLinkClick={this.onLinkClickHandler}
        />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/Header.js